import { Reservation as BaseReservation } from '@sagano/share/stores';
export class Reservation extends BaseReservation {}

export default new Reservation();
